// extracted by mini-css-extract-plugin
module.exports = {"emblaSlide":"Slide_emblaSlide__pqlP0"};